import React from "react";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import styles from "../Conversation/conversation.module.css";

export interface MessageType {
    text: string;
    replyOptions?: string[];
}

const Message: React.FC<{ msg: MessageType }> = ({ msg }) => {
    const { text } = msg;
    return (
        <div className={styles.messagebubble}>
            <div className={styles.triright}>
                <div className={styles.messagetext}>
                    <p>{text}</p>
                </div>
                {msg.replyOptions && (
                    <div className="flex flex-col gap-4 justify-between items-center px-4 pt-2 pb-4 left-0 ">
                        {msg.replyOptions.map((o, index) => {
                            if (o.length > 0) {
                                return (
                                    <p
                                        key={`options-${index}`}
                                        className="w-full text-center cursor-pointer bg-white rounded-lg border-solid border box-border border-blue-400 text-sm text-blue-400 py-2 px-4 hover:bg-blue-400 hover:text-white max-w-xs break-words"
                                    >
                                        {o}
                                    </p>
                                );
                            }
                        })}
                    </div>
                )}
            </div>
        </div>
    );
};

const Messages: React.FC<{ msgs: MessageType[] }> = (props) => {
    const { msgs } = props;
    return (
        <div style={{ height: "410px" }} className="overflow-y-auto">
            {msgs.map((m, index) => {
                return <Message msg={m} key={`message-${index}`} />;
            })}
        </div>
    );
};

export default Messages;
